import { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";
import { Button } from "react-bootstrap";

export type BreadcrumbItem = {
  title: string;
  link?: string;
};

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  const filteredItems = items.filter((item) => item.title);
  const navigate = useNavigate();

  return (
    <div
      style={{ borderBottom: "1px solid #E6E4E2", background: "#F8F8F8" }}
      className="breadcrumb-bar p-2 flex-grow-1 d-flex align-items-center gap-2"
    >
      <Button className='btn-blue-light' size='sm' onClick={() => void navigate(-1)} aria-label="Go back">
        <ArrowLeft size={16} />
      </Button>
      <nav aria-label="breadcrumb" className="d-flex align-items-center gap-1">
        {filteredItems.map((item, index) => (
          <Fragment key={item.link ?? item.title}>
            {index > 0 && (
              <ChevronRight size={16} className="text-muted" />
            )}
            {item.link ? (
              <Link
                to={item.link}
                style={{
                  textDecoration: "none",
                  fontWeight: 600,
                  color: "#2e6b9b",
                  fontSize: "15px",
                  letterSpacing: "-0.3px",
                }}
              >
                {item.title}
              </Link>
            ) : (
              <span
                style={{
                  fontWeight: 500,
                  color: "#87807b",
                  fontSize: "15px",
                  letterSpacing: "-0.3px",
                }}
                aria-current="page"
              >
                {item.title}
              </span>
            )}
          </Fragment>
        ))}
      </nav>
    </div>
  );
}
